import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { HeaderThree } from 'secondstep-components'

export const StyledHeaderThree = styled(HeaderThree)`
  color: ${themeGet('colors.darkerDarkBlue')};
  font-family: ${themeGet('fontFamilyBold')};
`
